
import Vue from 'vue'

export default Vue.extend({
  name: 'pd-menucomponent',

  data: function () {
    return {
      opened: false
    }
  },
  methods: {
    doclick: function () {
      this.opened = true;
      if (this.click) {
        this.click(this.datatopass,this.datatopass1)
      }
    },
    toggleOpen: function () {
      this.opened = !this.opened;
    }
  },
  props: {
    click: Function,
    label: String,
    datatopass: Number,
    datatopass1: Number,
    children: Array,
    currentactive: Number
  }
})
